<section
  class="container-wrapper"
  [ngClass]="'container-wrapper-theme-' + className()"
  [class.is-ltr]="!appTranslate.isRTL()"
>
  <mat-label class="label" [class.required]="!hideRequiredMarker() && radioGroupControl().hasValidator(Validators.required)">
    {{ label() || '' | translate }}
    @if (infoTooltip()) {
      <mat-icon class="help-icon" svgIcon="icon_info_24" [appTooltip]="infoTooltip() | translate" [position]="TooltipPosition.BELOW" />
    }
  </mat-label>
<mat-radio-group class="questionnaire-radio-group" [formControl]="radioGroupControl()">
  @for (option of options(); track option.value) {
    <mat-radio-button [value]="option.value">{{ option.label | translate }}</mat-radio-button>
  }
</mat-radio-group>
  @let firstError = getFirstError();
  @if (firstError) {
    <mat-error class="error-active">
      {{ firstError.message | translate }}
    </mat-error>
  }@else if(hintMessage()) {
    <mat-hint class="field-hint">
      {{ hintMessage() | translate }}
    </mat-hint>
  }
</section>
